export function createTripClient(transport) {
    return {
        /**
         * Whether this trip may be rated, by this rater, about this subject
         *
         * Requires scope: trip:rating-eligibility
         */
        getTripRatingEligibility(tripId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/trips/${encodeURIComponent(tripId)}/rating-eligibility`,
                body,
                options,
            });
        },
        /**
         * The trips the signed-in rider took
         *
         * Requires scope: trip:self
         */
        listMyTrips(from, to, options) {
            return transport.request({
                method: "GET",
                path: "/v1/me/trips",
                query: { from: from, to: to },
                options,
            });
        },
        /**
         * The trips an operator is watching
         *
         * Requires scope: trip:read, trip:workload:read
         */
        getTenantsTrips(tenantId, status, limit, after, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/trips`,
                query: { status: status, limit: limit, after: after },
                options,
            });
        },
        /**
         * Create from exact assignment request and quote references
         *
         * Requires scope: trip:workload:create
         */
        postTenantsTrips(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/trips`,
                body,
                options,
            });
        },
        /**
         * Apply an idempotent optimistic lifecycle transition
         *
         * Requires scope: trip:driver:transition, trip:rider:cancel, trip:workload:transition
         */
        postTenantsTripsTransitions(tenantId, tripId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/trips/${encodeURIComponent(tripId)}/transitions`,
                body,
                options,
            });
        },
        /**
         * Read as the rider driver or authorized workload
         *
         * Requires scope: trip:read
         */
        getTenantsTrips2(tenantId, tripId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/trips/${encodeURIComponent(tripId)}`,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=trip.js.map